// External links should use anchors to avoid react-router intercept
import data from "../../data/index.json";

export default function MyPortfolio() {
  return (
    <section className="portfolio-section" id="MyPortfolio">
      <div className="portfolio-container-box">
        <div className="portfolio-container">
          {/* <p className="sub-title">Recent Projects</p> */}
          <h1 className="section-heading">My Portfolio</h1>
          <p className="portfolio-subtext text-md">Selected projects showcasing cloud, DevOps, and web work.</p>
        </div>
        <div>
          <a href="https://github.com/mathebulansuku" target="_blank" rel="noopener noreferrer" aria-label="Open GitHub profile in a new tab">
            <button className="btn btn-github">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{marginRight: 8}}>
                <path d="M12 .5C5.73.5.9 5.33.9 11.6c0 4.87 3.15 8.99 7.51 10.45.55.1.75-.24.75-.53 0-.27-.01-.99-.02-1.94-3.05.66-3.7-1.47-3.7-1.47-.5-1.29-1.22-1.64-1.22-1.64-.99-.67.08-.66.08-.66 1.1.08 1.68 1.13 1.68 1.13.98 1.68 2.57 1.2 3.2.92.1-.71.38-1.2.69-1.47-2.43-.28-4.98-1.21-4.98-5.36 0-1.18.42-2.14 1.11-2.9-.11-.28-.48-1.41.11-2.94 0 0 .9-.29 2.95 1.11.86-.24 1.78-.36 2.7-.36.92 0 1.84.12 2.7.36 2.05-1.4 2.95-1.11 2.95-1.11.59 1.53.22 2.66.11 2.94.69.76 1.11 1.72 1.11 2.9 0 4.16-2.56 5.08-5 5.35.39.33.73.98.73 1.98 0 1.43-.01 2.58-.01 2.93 0 .29.2.64.76.53 4.35-1.46 7.5-5.58 7.5-10.45C23.1 5.33 18.27.5 12 .5Z"/>
              </svg>
              View GitHub
            </button>
          </a>
        </div>
      </div>
      <div className="portfolio-section-container">
        {data?.portfolio?.map((item, index) => (
          <div key={index} className="portfolio-section-card">
            <a
              className="portfolio-section-img"
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Open ${item.title}`}
            >
              <img src={item.src} alt={item.title} loading="lazy" />
              <div className="portfolio-img-overlay">
                <span className="portfolio-view-cta">View Project →</span>
              </div>
            </a>
            <div className="portfolio-section-card-content">
              <div>
                <h3 className="portfolio-section-title">{item.title}</h3>
                {item.description && (
                  <p className="portfolio-desc text-md">{item.description}</p>
                )}
              </div>
              <div className="portfolio-actions">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-primary portfolio-btn"
                >
                  {item.linkText || "Open Project"}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
